export default __webpack_public_path__ + "static/media/side-img-2.8b6d2d99.jpg";